import { ReactNode } from 'react';
import { LinkField, LinkFieldValue } from '@sitecore-jss/sitecore-jss-nextjs';
import { C12LinkedListEnhancedItemProps } from './C12LinkedListEnhancedItem.types';
import { Anchor, LinkedListEnhancedItemProps } from '@ahc-digital/component-library';
import { useConditionalRendering } from '@/shared/useConditionalRendering';
import { getDroplink } from '@/shared/param-utils';

function mapLinks(
  values: Array<LinkFieldValue> | undefined,
  renderLink: ReturnType<typeof useConditionalRendering>['renderLink']
): ReactNode[] {
  if (!values?.length) {
    return [];
  }

  return values.map((value, index) => (
    <Anchor key={index}>{renderLink({ value } as LinkField)}</Anchor>
  ));
}

export function GetLinkedListEnhancedItemModel(
  props?: C12LinkedListEnhancedItemProps
): LinkedListEnhancedItemProps {
  type t = LinkedListEnhancedItemProps;

  const { params, fields } = props || {};

  const { renderText, renderRichText, renderLink } = useConditionalRendering();

  return {
    headline: renderText(fields?.Headline),
    supportCopy: renderRichText(fields?.SupportCopy),
    headlineTag: getDroplink<t['headlineTag']>(params?.HeadlineTag, 'h3'),
    links: mapLinks(fields?.Links?.value, renderLink),
  };
}
